import React from "react"
import "./Iconos.css"
import { FaCrown } from "react-icons/fa"

const IconoPostulante = (props) => {
  return (
    <span
      className={
        "icono-mp" +
        (props.background ? " background-postulante" : "") +
        " noprint"
      }
    >
      <FaCrown />
    </span>
  )
}

export default IconoPostulante
